import type { Suggestion } from '../types/search/Suggestion';

/**
 * employee_code（item.code）での並び順:
 * 1) 数字のみ（例: "001"）を先に
 * 2) 数字のみ同士は数値昇順（ゼロ埋め無視）
 * 3) 片方が数字のみなら数字のみを先
 * 4) 英字+数値同士は、英字部→数値部（数値昇順）
 * 最後は label（日本語）昇順で安定化
 */
export const employeeCodeComparator = (
  a: Suggestion,
  b: Suggestion
): number => {
  const ac = a.code ?? '';
  const bc = b.code ?? '';

  const numOnly = /^\d+$/;
  const aIsNum = numOnly.test(ac);
  const bIsNum = numOnly.test(bc);

  // 片方のみ数値: 数値のみを先
  if (aIsNum && !bIsNum) return -1;
  if (!aIsNum && bIsNum) return 1;

  // 両方とも数値のみ: 数値昇順
  if (aIsNum && bIsNum) {
    const na = parseInt(ac, 10);
    const nb = parseInt(bc, 10);
    if (na !== nb) return na - nb;
    return a.label.localeCompare(b.label, 'ja');
  }

  // ここから英字+数値: 英字部 → 数値部
  const re = /^([^\d]*)(\d+)?$/;
  const [, aPrefix = '', aNumStr = ''] = ac.match(re) ?? [];
  const [, bPrefix = '', bNumStr = ''] = bc.match(re) ?? [];

  const p = aPrefix.localeCompare(bPrefix, 'ja', { sensitivity: 'base' });
  if (p !== 0) return p;

  const aNum = aNumStr ? parseInt(aNumStr, 10) : -1;
  const bNum = bNumStr ? parseInt(bNumStr, 10) : -1;
  if (aNum !== bNum) return aNum - bNum;

  return a.label.localeCompare(b.label, 'ja');
};
